import { Mascot, type MascotId } from './mascots';
import styles from '../App.module.css';

export interface MascotRowItem {
  id: MascotId;
  size?: number;
  title?: string;
}

interface MascotRowProps {
  items: Array<MascotId | MascotRowItem>;
  /** 個別size未指定時のデフォルト */
  size?: number;
  /** ゆらゆら浮遊アニメーション（reduced-motion時は自動で無効） */
  animated?: boolean;
  /** 画面幅で折り返すか（デフォルトtrue） */
  wrap?: boolean;
  className?: string;
}

export function MascotRow({
  items,
  size = 56,
  animated = true,
  wrap = true,
  className,
}: MascotRowProps) {
  return (
    <div
      className={`${styles.mascotRow} ${wrap ? '' : styles.mascotRowNowrap} ${className ?? ''}`}
    >
      {items.map((item, i) => {
        const it: MascotRowItem = typeof item === 'string' ? { id: item } : item;
        return (
          <span
            key={`${it.id}-${i}`}
            className={`${styles.mascotItem} ${animated ? styles.mascotFloat : ''}`}
            style={animated ? { animationDelay: `${i * 0.18}s` } : undefined}
          >
            <Mascot id={it.id} size={it.size ?? size} title={it.title} />
          </span>
        );
      })}
    </div>
  );
}
